import { createContext } from "react";

export const OEMContext = createContext({});
